<section class="nw_service_th" *ngIf="!loader && !showBusinesPlaceholder">
    <div class="service_se">
        <div class="heading_sert">
            <h3>All recharges
            </h3>
        </div>
        <div class="chip_services_list">
            <mat-chip-list>
              <mat-chip  [ngClass]="{'Graceful-box-active': selectedValue == '2'}" (click)="changeChip('2')"> Transactions </mat-chip>
                <mat-chip (click)="changeChip('0')" [ngClass]="{'Graceful-box-active': selectedValue == '0'}">Unused Business Packs </mat-chip>
                <mat-chip (click)="changeChip('1')" [ngClass]="{'Graceful-box-active': selectedValue == '1'}">Unused Employee Packs </mat-chip>
            </mat-chip-list>
        </div>
    </div>

 
    <div class="schedule-container" *ngIf="!loader && !hidediv && (selectedValue == '0' || selectedValue == '1') && subsData.length > 0">
    
      <table mat-table [dataSource]="subsData" class="custom-table">
          <ng-container matColumnDef="packName">
            <th mat-header-cell *matHeaderCellDef class="custom-header">Pack Name</th>
            <td mat-cell *matCellDef="let pack" class="custom-cell">
              {{ pack.planName }}
            </td>
          </ng-container>
      
          <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef class="custom-header">Description</th>
            <td mat-cell *matCellDef="let pack" class="custom-cell">
              {{ pack.planDescription }}
            </td>
          </ng-container>
      
          <ng-container matColumnDef="noOfUsers">
            <th mat-header-cell *matHeaderCellDef class="custom-header">No Of Users</th>
            <td mat-cell *matCellDef="let pack" class="custom-cell">
              {{ pack.noOfUsers }}
            </td>
          </ng-container>
      
          <ng-container matColumnDef="noOfUsersUsed">
            <th mat-header-cell *matHeaderCellDef class="custom-header">No Of Users Used</th>
            <td mat-cell *matCellDef="let pack" class="custom-cell">
              {{ pack.noOfUsersActivate }}
            </td>
          </ng-container>
      
          <ng-container matColumnDef="noOfEntity">
            <th mat-header-cell *matHeaderCellDef class="custom-header">No Of Entity</th>
            <td mat-cell *matCellDef="let pack" class="custom-cell">
              {{ pack.noOfEntity }}
            </td>
          </ng-container>
      
          <ng-container matColumnDef="noOfEntitiesUsed">
            <th mat-header-cell *matHeaderCellDef class="custom-header">No Of Entities Used</th>
            <td mat-cell *matCellDef="let pack" class="custom-cell">
              {{ pack.noOfEntityActivate }}
            </td>
          </ng-container>
          <ng-container matColumnDef="plancost">
            <th mat-header-cell *matHeaderCellDef class="custom-header">Plan Cost</th>
            <td mat-cell *matCellDef="let pack" class="custom-cell">
              {{ pack.currency_symbol }}{{ pack.unitCost }}
            </td>
          </ng-container>
          <ng-container matColumnDef="validity">
            <th mat-header-cell *matHeaderCellDef class="custom-header">Validity</th>
            <td mat-cell *matCellDef="let pack" class="custom-cell">
              {{ pack.validity }} days
            </td>
          </ng-container>
      
          <ng-container matColumnDef="purchasedOn">
            <th mat-header-cell *matHeaderCellDef class="custom-header">Purchased On</th>
            <td mat-cell *matCellDef="let pack" class="custom-cell">
              {{ pack.creationDate | date:'dd/MM/yyyy' }}
            </td>
          </ng-container>
      
          <tr mat-header-row *matHeaderRowDef="displayedColumns2" class="custom-header-row"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns2;" class="custom-row"></tr>
        </table>
   
      </div>
 

      <mat-card *ngIf="!loader && !hidediv && selectedValue == '2' && transactionData.length > 0">
       <div class="schedule-container" >
        <table mat-table [dataSource]="transactionData" class="custom-table">
          <ng-container matColumnDef="packName">
            <th mat-header-cell *matHeaderCellDef class="custom-header">Pack Name</th>
            <td mat-cell *matCellDef="let pack" class="custom-cell">
              {{ pack.planName }}
            </td>
          </ng-container>
      
          <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef class="custom-header">Description</th>
            <td mat-cell *matCellDef="let pack" class="custom-cell">
              {{ pack.description }}
            </td>
          </ng-container>
      
          <ng-container matColumnDef="noOfUsers">
            <th mat-header-cell *matHeaderCellDef class="custom-header">No Of Users</th>
            <td mat-cell *matCellDef="let pack" class="custom-cell">
              {{ pack.noOfUsers }}
            </td>
          </ng-container>
      
      
          <ng-container matColumnDef="noOfEntity">
            <th mat-header-cell *matHeaderCellDef class="custom-header">No Of Entity</th>
            <td mat-cell *matCellDef="let pack" class="custom-cell">
              {{ pack.noOfEntity }}
            </td>
          </ng-container>
      
          <ng-container matColumnDef="plancost">
            <th mat-header-cell *matHeaderCellDef class="custom-header">Plan Cost</th>
            <td mat-cell *matCellDef="let pack" class="custom-cell">
              {{ pack.currency_symbol }}{{ pack.unitCost }}
            </td>
          </ng-container>
          <ng-container matColumnDef="totalCost">
            <th mat-header-cell *matHeaderCellDef class="custom-header">Total Cost</th>
            <td mat-cell *matCellDef="let pack" class="custom-cell">
              {{ pack.currency_symbol }}{{ pack.totalCost }}
            </td>
          </ng-container>
      
          <ng-container matColumnDef="validity">
            <th mat-header-cell *matHeaderCellDef class="custom-header">Validity</th>
            <td mat-cell *matCellDef="let pack" class="custom-cell">
              {{ pack.validity }} days
            </td>
          </ng-container>
      
          <ng-container matColumnDef="purchasedOn">
            <th mat-header-cell *matHeaderCellDef class="custom-header">Purchased On</th>
            <td mat-cell *matCellDef="let pack" class="custom-cell">
              {{ pack.creationDate | date:'dd/MM/yyyy' }}
            </td>
          </ng-container>
          <ng-container matColumnDef="transactionid">
            <th mat-header-cell *matHeaderCellDef class="custom-header">Transaction Id</th>
            <td mat-cell *matCellDef="let pack" class="custom-cell">
              {{ pack.paymentRef }}
            </td>
          </ng-container>
      
          <tr mat-header-row *matHeaderRowDef="displayedColumns" class="custom-header-row"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="custom-row"></tr>
        </table>
      </div>
    </mat-card>
      


      
    <!-- Placeholder design html start for subs -->
    <div class="placeholder_started" *ngIf="!loader && !hidediv && (subsData.length == 0 && (selectedValue == '0' || selectedValue == '1' ))">
      <div class="row">
        
        
        <div class="col-sm-4">
          <div class="dashboard_new">
            <mat-card>
                <div class="upload_sectio">
                <div class="icm_img">
                  <img src="./assets/images/plans-1.jpg">
                </div>
                <mat-card-title>No recharge data to show here</mat-card-title>
                <mat-card-content>We found no recharge pack purchased by you. Check <span class="ghtunderline" (click)="openLink('https://lookzup.com/help')"> help documents</span> on how to purchase one and utilize them.
              </mat-card-content>
                <div class="watch_vc_btn">
                <button mat-stroked-button color="primary" (click)="openLink('https://lookzup.com/help')">
                  <mat-icon>help</mat-icon>
                  See help doc
                </button>
                </div>
                </div>
            </mat-card>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="dashboard_new">
            <mat-card>
                <div class="upload_sectio">
                <div class="icm_img">
                  <img src="./assets/images/helpsupport.png">
                </div>
                <mat-card-title>Having any issue?</mat-card-title>
                <mat-card-content>If you already purchased a recharge pack and it's not appearing here, contact our support team with full info.
              </mat-card-content>
                <div class="watch_vc_btn">
                  <button mat-stroked-button color="primary" (click)="opencontact()">
                      <mat-icon>support_agent</mat-icon>
                      Contact support
                  </button>
                </div>
                </div>
            </mat-card>
          </div>
        </div>
      </div>
    
    </div>
    
    
    <!-- Placeholder design html start for trans -->
    <div class="placeholder_started" *ngIf="!loader && !hidediv && (transactionData.length == 0  && selectedValue == '2')">
      <div class="row">
        
        
        <div class="col-sm-4">
          <div class="dashboard_new">
            <mat-card>
                <div class="upload_sectio">
                <div class="icm_img">
                  <img src="./assets/images/plans-1.jpg">
                </div>
                <mat-card-title>No recharge data to show here</mat-card-title>
                <mat-card-content>We found no recharge pack purchased by you. Check <span class="ghtunderline" (click)="openLink('https://lookzup.com/help')"> help documents</span> on how to purchase one and utilize them.
              </mat-card-content>
                <div class="watch_vc_btn">
                <button mat-stroked-button color="primary" (click)="openLink('https://lookzup.com/help')">
                  <mat-icon>help</mat-icon>
                  See help doc
                </button>
                </div>
                </div>
            </mat-card>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="dashboard_new">
            <mat-card>
                <div class="upload_sectio">
                <div class="icm_img">
                  <img src="./assets/images/helpsupport.png">
                </div>
                <mat-card-title>Having any issue?</mat-card-title>
                <mat-card-content>If you already purchased a recharge pack and it's not appearing here, contact our support team with full info.
              </mat-card-content>
                <div class="watch_vc_btn">
                  <button mat-stroked-button color="primary" (click)="opencontact()">
                      <mat-icon>support_agent</mat-icon>
                      Contact support
                  </button>
                </div>
                </div>
            </mat-card>
          </div>
        </div>
      </div>
    
    </div>


</section>
      


<!-- no business and no subs info -->
<section class="nw_service_th" *ngIf="!loader && showBusinesPlaceholder">
    <div class="service_se">
        <div class="heading_sert">
            <h3>All recharges
            </h3>
        </div>
    </div>

          <div class="placeholder_started">
            <div class="row">
              <div class="col-sm-4">
                <div class="dashboard_new">
                  <mat-card>
                      <div class="upload_sectio">
                     <div class="icm_img">
                        <img src="./assets/images/business-create.png" style="width: 110px;">
                     </div>
                     <mat-card-title>No business added yet</mat-card-title>
                     <mat-card-content>Your purchased recharge list will appear here. For that you need to create a business first. It's easy and takes only 2 minutes.
                    </mat-card-content>
                     <div class="create_btnyh">
                        <button mat-flat-button color="primary" (click)="selectcountry()">
                            <mat-icon>add</mat-icon> 
                           Create a business
                        </button>
                     </div>
                     </div>
                  </mat-card>
               </div>
              </div>
              <div class="col-sm-4">
                <div class="dashboard_new">
                  <mat-card>
                      <div class="upload_sectio">
                     <div class="icm_img">
                        <img src="./assets/images/plans-1.jpg">
                     </div>
                     <mat-card-title>No recharge data to show here</mat-card-title>
                     <mat-card-content>We found no recharge pack purchased by you. Check <span class="ghtunderline" (click)="openLink('https://lookzup.com/help')">  help documents</span> on how to purchase one and utilize them.
                    </mat-card-content>
                     <div class="watch_vc_btn">
                        <button mat-stroked-button color="primary" (click)="openLink('https://lookzup.com/help')">
                           <mat-icon>help</mat-icon>
                           See help doc
                        </button>
                     </div>
                     </div>
                  </mat-card>
               </div>
              </div>
              <div class="col-sm-4">
                <div class="dashboard_new">
                  <mat-card>
                      <div class="upload_sectio">
                     <div class="icm_img">
                        <img src="./assets/images/helpsupport.png">
                     </div>
                     <mat-card-title>Having any issue?</mat-card-title>
                     <mat-card-content>If you already purchased a recharge pack and it's not appearing here, contact our support team with full info.
                    </mat-card-content>
                     <div class="watch_vc_btn">
                        <button mat-stroked-button color="primary" (click)="opencontact()">
                           <mat-icon>support_agent</mat-icon>
                           Contact support
                        </button>
                     </div>
                     </div>
                  </mat-card>
               </div>
              </div>
            </div>
        
          </div>
</section>